<template>
  <div class="row multiple-ranking-lists mb-3">
    <div
      v-for="(val, key) in settings"
      :key="key"
      :class="`ranking-list-wrapper col-${colWidth(val)}`"
      class="mt-3"
    >
      <ranking-list
        :title="key.includes('channel') ? `${channelName} League Table`: val.title"
        :items="rankingLists[key]"
        :active-id="data.id"
        :settings="val"
        :client-width="clientWidth"
      />
    </div>
  </div>
</template>

<script>
import RankingList from '@/components/RankingList'

export default {
  components: {
    RankingList,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
    rankingLists: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    clientWidth: {
      type: Number,
      default: null,
    },
  },
  computed: {
    channelName () {
      return this.data && this.data.channel ? this.data.channel.name
        : (this.data && this.data.channel_content_type && this.data.channel_content_type.channel
          ? this.data.channel_content_type.channel.name
          : 'Channel')
    },
  },

  methods: {
    colWidth (val) {
      return this.clientWidth <= 992
        ? 12
        : (this.clientWidth <= 1440
          ? (val.colWidth > 6
            ? 12
            : 6)
          : val.colWidth
        )
    },
  },
}
</script>

<style lang="scss" scoped>
  // .multiple-ranking-list {
  //   .ranking-list-wrapper {
  //     min-width: 600px;
  //   }
  // }
</style>
